import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  createGeneralExpense,
  deleteGeneralExpense,
  getAllGeneralExpenses,
  getGeneralExpenseById,
  updateGeneralExpense,
} from "./general-expenses.service";

export const useGetAllGeneralExpenses = () => {
  return useQuery({
    queryKey: ["general-expenses"],
    queryFn: getAllGeneralExpenses,
  });
};

export const useGetGeneralExpenseById = (generalExpenseId) => {
  return useQuery({
    queryKey: ["general-expenses", generalExpenseId],
    queryFn: () => getGeneralExpenseById(generalExpenseId),
    enabled: Boolean(generalExpenseId),
  });
};

export const useCreateGeneralExpenseMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: createGeneralExpense,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["general-expenses"] });
    },
  });
};

export const useUpdateGeneralExpenseMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ generalExpenseId, generalExpenseData }) =>
      updateGeneralExpense(generalExpenseId, generalExpenseData),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["general-expenses"] });
    },
  });
};

export const useDeleteGeneralExpenseMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: deleteGeneralExpense,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["general-expenses"] });
    },
  });
};